import React from 'react';
import { intlMessage } from 'constants/propTypes';
import Message from 'components/Message';

const EmptyDetails = ({ text }) => <Message className="text--light" message={text} />;

EmptyDetails.propTypes = {
  text: intlMessage,
};

export default EmptyDetails;
